import React from 'react';
import CodeMirror from 'react-codemirror';
import { Button, Grid, Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import Video from './Video';

const dev = false && process.env.NODE_ENV !== 'production';
// const PORT = process.env.PORT || 3001;
const PRODUCTION_CHAT_SERVER = `wss://${window.location.host}:${window.location.port}`;
const DEV_CHAT_SERVER = 'ws://localhost:3001';
const chatServerUrl = dev ? DEV_CHAT_SERVER : PRODUCTION_CHAT_SERVER;


const isBrowser = typeof window !== 'undefined';
isBrowser ? function(){
  require('codemirror/mode/javascript/javascript');
  require('codemirror/addon/lint/lint');
  require('codemirror/addon/lint/javascript-lint');
}() : undefined;

export class Code extends React.Component {
   constructor(props) {
    super(props);
    this.state = {
      message : {
        code : '',
        evaluated_code : "",
        room : this.props.match.url,
        type : '',
        cursor: {
          line: 0, //this.refs.editor.getCodeMirror().getCursor().line,
          ch: 0 //this.refs.editor.getCodeMirror().getCursor().ch
        }
      }
    };

    this.evaluateCode = this.evaluateCode.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this);
    this.updateCode = this.updateCode.bind(this);
  }

  async componentWillMount() {
    const initialMsg ={
      room: this.props.match.url,
      type: "initialMsg",
      cursor: {
        line: 0, //this.refs.editor.getCodeMirror().getCursor().line,
        ch: 0 //this.refs.editor.getCodeMirror().getCursor().ch
      }
    }
    // const url = `ws://${window.location.hostname}:${PORT}`; // for localhost only. comment when deploying
    // const url = `wss://${window.location.hostname}:${PORT}`; //for deployment only. uncomment when deploying
    const url = chatServerUrl
    console.log(`url:${url}`);
    this.socket = new WebSocket(url);
    this.socket.onopen = () => {
      console.log('connected to server');
      // send initial msg
      this.socket.send(JSON.stringify(initialMsg));
    }
    this.socket.onmessage = (t) => {
      const newMessage = JSON.parse(t.data);

      switch(newMessage.type) {
        case "updateCode":
          this.setState( {message: newMessage});
          this.refs.editor.getCodeMirror().setCursor(this.state.message.cursor.line, this.state.message.cursor.ch);
        break;

        case "evaluateCode":
          this.setState ({message:newMessage});
          this.refs.editor.getCodeMirror().setCursor(this.state.message.cursor.line, this.state.message.cursor.ch);
        break;
      }
    }
  }

  updateCode(newCode){
    const message = {
        code: newCode,
        evaluated_code: this.state.message.evaluated_code,
        room: this.state.message.room,
        type: "updateCode",
        cursor: {line: this.refs.editor.getCodeMirror().getCursor().line, ch:this.refs.editor.getCodeMirror().getCursor().ch}
    }
    this.socket.send(JSON.stringify(message));
  }

  handleSubmit(event){
    event.preventDefault();
    this.evaluateCode(this.state.message.code);
  }

evaluateCode (code){
      let message = {
        code: code,
        evaluated_code: "",
        room: this.state.message.room,
        type: "evaluateCode",
        cursor: {line: this.refs.editor.getCodeMirror().getCursor().line, ch:this.refs.editor.getCodeMirror().getCursor().ch}
      };
      try {
        const evaluated_code = eval(code);

        if (evaluated_code === undefined){
          message.evaluated_code = "undefined"
        } else {
          message.evaluated_code = evaluated_code;
        }
      } catch (e) {
          message.evaluated_code = e.toString();
      }
      this.socket.send(JSON.stringify(message));
  }

  render() {
      let options = {
        lineNumbers: true,
        mode: 'javascript',
        lineWrapping: true,
        lint: true,
        gutters: [
          'CodeMirror-lint-markers',
        ],
        theme: "xq-dark"
      };

    

    return (
        <Grid>
          <Row className="show-grid">
            <Col xs={12} sm={14} md={9} lg={10}>

                <form  onSubmit={this.handleSubmit}>

                  <CodeMirror value={this.state.message.code} ref="editor" onChange={this.updateCode} options={options}  evaluateCode={this.evaluateCode}  autoFocus={true}/>
                  <span >
                    <small style={{color: "tomato",fontSize: "15px"}}>Output</small>
                    <Button style={{float: "right"}} type="submit">  Run ...  </Button>
                    <br/>
                    <span style={{color: "white",fontSize: "15px"}}>
                    {this.state.message.evaluated_code}
                    </span>
                  </span>
                </form>

            </Col>
            <Col xs={4} sm={3} md={3}  lg={2}>
              <Video room = {this.state.message.room} />
            </Col>
          </Row>
        </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Code.js